/**
 * Storage Adapter
 * Wraps storage utilities to provide adapter interface
 */

import type { StorageAdapter as IStorageAdapter } from '../types/adapters.types';
import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { clearAllLocalStorage, clearAllSessionStorage } from '../../../utils/localStorage.utils';
import { clearAllSecureStorage } from '@hsus-dev/session-policy';
import { clearRegistrationData } from '../../../utils/secureRegistrationStorage.utils';
import { tokenService } from '../../../services/token.service';
import { clearMsalCacheSynchronously } from '../../../utils/msalCache.utils';

/**
 * Create Storage adapter
 * 
 * @param msalInstance - MSAL instance for cache clearing (can be null)
 * @returns StorageAdapter implementation
 */
export function createStorageAdapter(
  msalInstance: IPublicClientApplication | null
): IStorageAdapter {
  return {
    clearTokens: async () => {
      await tokenService.removeTokens();
    },
    clearSecureStorage: async () => {
      clearAllSecureStorage();
      clearRegistrationData();
    },
    clearAllStorage: async () => {
      clearAllSessionStorage();
      clearAllLocalStorage();
    },
    clearMsalCache: (account: AccountInfo | null) => {
      clearMsalCacheSynchronously(msalInstance, account);
    },
  };
}
